var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container p-2"},[(!_vm.isLogin)?_c('before-login'):_c('after-login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }